var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSs4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 46,
    viewBox: "0 0 54 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_408868416"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.0137 45.7734H27C26.5859 45.7734 26.2754 45.4629 26.2754 45.0488C26.2754 44.6348 26.5859 44.3242 27 44.3242H48.0137C50.1875 44.3242 52.0508 42.2539 52.0508 39.7695V37.4922C52.0508 35.0078 50.1875 33.041 48.0137 33.041C47.5996 33.041 47.2891 32.7305 47.2891 32.3164C47.2891 31.9023 47.5996 31.5918 48.0137 31.5918C51.0156 31.5918 53.5 34.2832 53.5 37.4922V39.7695C53.5 41.3223 52.8789 42.875 51.9473 44.0137C50.8086 45.1523 49.4629 45.7734 48.0137 45.7734Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.0449 10.7852H27C26.5859 10.7852 26.2754 10.4746 26.2754 10.0605C26.2754 9.64648 26.5859 9.33594 27 9.33594H43.0449C43.459 9.33594 43.7695 9.64648 43.7695 10.0605C43.7695 10.4746 43.459 10.7852 43.0449 10.7852Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.7754 40.4941C52.3613 40.4941 52.0508 40.1836 52.0508 39.7695V6.23047C52.0508 3.74609 50.1875 1.67578 47.9102 1.67578H43.7695V31.5918H48.3242C48.7383 31.5918 49.0488 31.9023 49.0488 32.3164C49.0488 32.7305 48.7383 33.041 48.3242 33.041H43.0449C42.6309 33.041 42.3203 32.7305 42.3203 32.3164V0.951172C42.3203 0.537109 42.6309 0.226562 43.0449 0.226562H47.9102C51.0156 0.226562 53.5 2.91797 53.5 6.23047V39.7695C53.5 40.1836 53.1895 40.4941 52.7754 40.4941Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 45.7734H6.08984C2.98438 45.7734 0.5 43.082 0.5 39.7695V37.4922C0.5 35.9395 1.12109 34.3867 2.15625 33.3516C3.19141 32.2129 4.53711 31.5918 6.08984 31.5918C6.50391 31.5918 6.81445 31.9023 6.81445 32.3164C6.81445 32.7305 6.50391 33.041 6.08984 33.041C3.8125 33.041 1.94922 35.0078 1.94922 37.4922V39.7695C1.94922 42.2539 3.8125 44.3242 6.08984 44.3242H27C27.4141 44.3242 27.7246 44.6348 27.7246 45.0488C27.7246 45.4629 27.4141 45.7734 27 45.7734Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 10.7852H10.9551C10.541 10.7852 10.2305 10.4746 10.2305 10.0605C10.2305 9.64648 10.541 9.33594 10.9551 9.33594H27C27.4141 9.33594 27.7246 9.64648 27.7246 10.0605C27.7246 10.4746 27.4141 10.7852 27 10.7852Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.22461 40.4941C0.810547 40.4941 0.5 40.1836 0.5 39.7695V6.23047C0.5 2.91797 2.98438 0.226562 6.08984 0.226562H10.9551C11.3691 0.226562 11.6797 0.537109 11.6797 0.951172V32.3164C11.6797 32.7305 11.3691 33.041 10.9551 33.041H5.67578C5.26172 33.041 4.95117 32.7305 4.95117 32.3164C4.95117 31.9023 5.26172 31.5918 5.67578 31.5918H10.2305V1.67578H6.08984C3.8125 1.67578 1.94922 3.74609 1.94922 6.23047V39.7695C1.94922 40.1836 1.63867 40.4941 1.22461 40.4941Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3516 26.5195H16.6484C16.3379 26.5195 16.1309 26.3125 16.0273 26.1055C15.8203 25.7949 15.9238 25.4844 16.1309 25.2773L26.4824 14.9258C26.5859 14.8223 26.793 14.7188 27 14.7188C27.207 14.7188 27.3105 14.8223 27.5176 14.9258L37.8691 25.2773C38.0762 25.4844 38.0762 25.7949 37.9727 26.1055C37.8691 26.3125 37.6621 26.5195 37.3516 26.5195ZM18.4082 25.0703H35.5918L27 16.4785L18.4082 25.0703Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1094 40.3906H17.9941C17.5801 40.3906 17.2695 40.0801 17.2695 39.666V25.7949C17.2695 25.3809 17.5801 25.0703 17.9941 25.0703C18.4082 25.0703 18.7188 25.3809 18.7188 25.7949V38.9414H35.3848V25.7949C35.3848 25.3809 35.6953 25.0703 36.1094 25.0703C36.5234 25.0703 36.834 25.3809 36.834 25.7949V39.666C36.834 40.0801 36.5234 40.3906 36.1094 40.3906Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0371 40.3906C30.623 40.3906 30.3125 40.0801 30.3125 39.666V33.4551H23.6875V39.666C23.6875 40.0801 23.377 40.3906 22.9629 40.3906C22.5488 40.3906 22.2383 40.0801 22.2383 39.666V32.7305C22.2383 32.3164 22.5488 32.0059 22.9629 32.0059H31.0371C31.4512 32.0059 31.7617 32.3164 31.7617 32.7305V39.666C31.7617 40.0801 31.4512 40.3906 31.0371 40.3906Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSs4);
export default __webpack_public_path__ + "static/media/ss4.53ed793dd1ddfdcc36c52b8c66d0902c.svg";
export { ForwardRef as ReactComponent };